import { glideConfig } from "../library/glide";
import handleMediaQueryChange from "../utilities/helpers/_media_query";

const snNowMobile = () => {
    const snNowPlugins = document.querySelectorAll("[data-sn-now] .glide");

    if (snNowPlugins.length === 0) return;

    snNowPlugins.forEach((plugin) => {
        glideConfig(plugin, {
            type: "slider",
            focusAt: 0,
            startAt: 0,
            perView: 2,
            keyboard: true,
            rewind: false,
            peek: 0,
            gap: 12,
            bound: true,
        });
    });
};

const snNowSlider = () => {
    handleMediaQueryChange(snNowMobile, null);
};

const initializeSnNow = () => {
    snNowSlider();
};

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeSnNow);
} else {
    initializeSnNow();
}

export { snNowSlider };
